
import { client } from 'utils/axios';
import { ApiResponse, InvoiceFormValues, VoteData, VoteFormValues } from 'types';
import { EndPoints } from 'constants/enums';
import { convertDateFormat } from 'utils';

const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

// TOCHECK 顯然沒有用什麼client之類的管理, 只用fetch可以進行蟲是之類的設定嗎
export const getVoteData = async (): Promise<VoteData> => {
	try {
		const response = await client.get(EndPoints.GET_VOTE_DATA);
		const result = {
			red: response.data?.data?.red || 0,
			white: response.data?.data?.white || 0,
		}
		return result;
	} catch (err: any) {
		throw new Error('get vote data error');
	}
};

export const vote = async (formValues: VoteFormValues): Promise<ApiResponse> => {
	try {
		const payload = {
			"vote_option": formValues.option,
			"vote_reason": formValues.reason,
			"email": formValues.email,
			"name": formValues.name,
			"phone": formValues.phone,
			"id_last5": formValues.idLast5
		}
		const response = await client.post(EndPoints.VOTE, payload);

		const apiResponse: ApiResponse = {
			isSent: true,
			isSuccess: response.data.is_success,
			message: response.data.message,
		};

		return apiResponse
	} catch (err: any) {
		throw new Error('vote failed');
	}

// 	{
// 	"is_success": true,
// 	"message": "Vote submitted successfully"
// }
// 	{
// 	"is_success": false,
// 	"message": "Duplicate vote: You have already voted today."
// }

};

export const getPresignedUrl = async (filename: string): Promise<ApiResponse> => {
	try {
		const payload = {
			"filename": filename
		}
		const response = await client.post(EndPoints.GET_UPLOAD_PRESIGNED_URL, payload);

		const apiResponse: ApiResponse = {
			isSent: true,
			isSuccess: response.data.is_success,
			data: {
				blobname: response.data.stored_filename,
				url: response.data.url
			}
		};
		return apiResponse
	} catch (err: any) {
		throw new Error('generate failed');
	}
	
	// "is_success": true,
	// "stored_filename": "05caae374e00455abdceb05a20d7ec65.png",
	// "url": 
};

export const setUploadedPublic = async (blobname: string): Promise<ApiResponse> => {
	try {
		const payload = {
			"filename": blobname
		}
		const response = await client.post(EndPoints.FILE_UPLOADED, payload);

		const apiResponse: ApiResponse = {
			isSent: true,
			isSuccess: response.data.is_success,
			data: {
				url: response.data.url
			}
		};
		return apiResponse
	} catch (err: any) {
		throw new Error('generate failed');
	}
	
	// "is_success": true,
	// "url": 
};

export const registerInvoice = async (formValues: InvoiceFormValues): Promise<ApiResponse> => {
	try {
		// 後端的日期要從 yyyy/mm/dd 換成 yyyy-mm-dd
		const payload = {
			"invoice_type": formValues.type,
			"invoice_number": formValues.number,
			"purchase_date": convertDateFormat(formValues.date || ''),
			"random_code": formValues.code,
			"name": formValues.name,
			"phone": formValues.phone,
			"email": formValues.email,
			"zipcode": formValues.zipcode,
			"address": formValues.address,
			"files_url": formValues.filesUrl,
		}
		const response = await client.post(EndPoints.REGISTER_INVOICE, payload);

		const apiResponse: ApiResponse = {
			isSent: true,
			isSuccess: response.data.is_success,
			message: response.data.message
		};
		return apiResponse
	} catch (err: any) {
		throw new Error('upload failed');
	}

// 	{
// 	"is_success": true
// }
// 	{
// 	"is_success": false,
// 	"message": "Duplicate invoice."
// }
};


